import { type Column } from "@tanstack/react-table";
import { getBodyCellProps } from "./utils/getBodyCellProps";

interface TableRowSkeletonProps<TData> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: Column<TData, any>[];
}

export function TableRowSkeleton<TData>({
  columns,
}: TableRowSkeletonProps<TData>) {
  return (
    <tr className="border-b">
      {columns.map((column) => {
        const { style, className, innerStyle, innerClassName } =
          getBodyCellProps(column);
        const body = (
          <div className="bg-surface-hover h-4 w-3/5 animate-pulse rounded-full" />
        );

        return (
          <td key={column.id} style={style} className={className}>
            {innerStyle || innerClassName ? (
              <div style={innerStyle} className={innerClassName}>
                {body}
              </div>
            ) : (
              body
            )}
          </td>
        );
      })}
    </tr>
  );
}
